const STATUS_STYLE = {
  matched: { bg: '#00D26A22', fg: '#00D26A', label: 'Matched' },
  unsure: { bg: '#FFD70022', fg: '#FFD700', label: 'Check' },
  unmatched: { bg: '#E04A3F22', fg: '#E04A3F', label: 'No match' },
};

export default function OcrReviewTable({ rows, setRow, allowManualBarcode }) {
  return (
    <div className="overflow-x-auto" data-testid="ocr-review-table">
      <table className="w-full text-xs">
        <thead>
          <tr className="text-zinc-400 text-left">
            <th className="py-2 pr-2">Use</th>
            <th className="py-2 pr-2">From screenshot</th>
            <th className="py-2 pr-2">Library match</th>
            <th className="py-2 pr-2 text-right">Price £</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <OcrRow key={i} r={r} i={i} setRow={setRow} allowManualBarcode={allowManualBarcode} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

function OcrRow({ r, i, setRow, allowManualBarcode }) {
  const st = STATUS_STYLE[r.status] || STATUS_STYLE.unmatched;
  const options = r.candidates || [];
  return (
    <tr className="border-t border-zinc-800 align-top" data-testid={`ocr-row-${i}`}>
      <td className="py-2 pr-2">
        <input
          type="checkbox"
          checked={r.include}
          disabled={!r.match_barcode}
          onChange={(e) => setRow(i, { include: e.target.checked })}
          className="accent-[#00D26A]"
          data-testid={`ocr-row-include-${i}`}
        />
      </td>
      <td className="py-2 pr-2 text-zinc-300 max-w-[220px]">
        <div className="truncate" title={r.extracted_title || ''}>{r.extracted_title || '—'}</div>
        {r.extracted_barcode && <div className="font-mono text-zinc-500">{r.extracted_barcode}</div>}
        <span className="inline-block mt-1 px-2 py-0.5 rounded-full text-[10px] font-bold" style={{ background: st.bg, color: st.fg }} data-testid={`ocr-row-status-${i}`}>
          {st.label}{r.confidence ? ` · ${Math.round(r.confidence * 100)}%` : ''}
        </span>
      </td>
      <td className="py-2 pr-2">
        <MatchPicker r={r} i={i} options={options} setRow={setRow} allowManualBarcode={allowManualBarcode} />
      </td>
      <td className="py-2 text-right">
        <input
          type="number"
          step="0.01"
          min="0"
          value={r.price ?? ''}
          onChange={(e) => setRow(i, { price: e.target.value === '' ? null : parseFloat(e.target.value) })}
          className="w-20 bg-black border border-zinc-800 rounded px-2 py-1 text-right font-mono focus:outline-none focus:border-[#00D26A]"
          data-testid={`ocr-row-price-${i}`}
        />
      </td>
    </tr>
  );
}

function MatchPicker({ r, i, options, setRow, allowManualBarcode }) {
  const pick = (barcode) => {
    const c = options.find((o) => o.barcode === barcode);
    setRow(i, { match_barcode: barcode || null, match_title: c?.title || null, include: !!barcode, status: barcode ? 'matched' : r.status });
  };
  return (
    <div className="space-y-1 min-w-[200px]">
      {options.length > 0 && (
        <select
          value={r.match_barcode || ''}
          onChange={(e) => pick(e.target.value)}
          className="w-full bg-black border border-zinc-800 rounded px-2 py-1 text-zinc-200"
          data-testid={`ocr-row-match-select-${i}`}
        >
          <option value="">— not in this list —</option>
          {options.map((o) => (
            <option key={o.barcode} value={o.barcode}>
              {o.title} ({Math.round(o.score * 100)}%)
            </option>
          ))}
        </select>
      )}
      {allowManualBarcode && (
        <input
          placeholder="Type barcode"
          value={r.match_barcode || ''}
          onChange={(e) => setRow(i, { match_barcode: e.target.value.replace(/\D/g, '') || null, include: !!e.target.value, status: 'matched' })}
          className="w-full bg-black border border-zinc-800 rounded px-2 py-1 font-mono text-zinc-200"
          data-testid={`ocr-row-barcode-input-${i}`}
        />
      )}
      {r.match_barcode && <div className="font-mono text-[10px] text-zinc-500">{r.match_barcode}</div>}
    </div>
  );
}
